import { Link } from 'react-router-dom';
import { mangaList } from '@/mocks/comics';
import ComicsCard from '@/components/feature/ComicsCard';

export default function FeaturedSection() {
  const featured = mangaList.filter((m) => m.featured);

  return (
    <section className="py-14 md:py-20 bg-background-100" aria-labelledby="featured-heading">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2
              id="featured-heading"
              className="font-heading font-bold text-2xl md:text-3xl text-foreground-900"
            >
              精选推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-1">
              编辑团队精心挑选的高品质韩漫
            </p>
          </div>
          <Link
            to="/category/all"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors font-medium whitespace-nowrap"
          >
            查看全部
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-5 md:gap-6">
          {featured.concat(featured).slice(0, 5).map((manga) => (
            <ComicsCard key={`featured-${manga.id}`} manga={manga} />
          ))}
        </div>
      </div>
    </section>
  );
}